/**
 * What changed between the draft and a saved version, said in the Studio's own terms.
 */
import clsx from 'clsx'

export function DiffList({
  label,
  values,
  tone,
}: {
  label: string
  values: string[]
  tone: 'green' | 'red' | 'amber'
}) {
  if (values.length === 0) return null
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1">
      <span
        className={clsx(
          'shrink-0 text-[9px] uppercase tracking-[0.12em]',
          tone === 'green' ? 'text-emerald-300' : tone === 'red' ? 'text-red-300' : 'text-amber-200',
        )}
      >
        {label}
      </span>
      {values.map((value) => (
        <span
          key={value}
          className={clsx(
            'rounded border px-1 py-0.5 text-[10px]',
            tone === 'green'
              ? 'border-emerald-400/20 bg-emerald-400/[0.08] text-emerald-200'
              : tone === 'red'
                ? 'border-red-400/20 bg-red-400/[0.08] text-red-200'
                : 'border-amber-300/20 bg-amber-300/[0.08] text-amber-100',
          )}
        >
          {value}
        </span>
      ))}
    </div>
  )
}
